import Swiper from 'swiper';
import {Navigation} from 'swiper/modules';

// import MicroModal from 'micromodal';
import AWN from "awesome-notifications"
import 'awesome-notifications/dist/style.css'
import $ from 'jquery';
import _ from 'lodash'
import TransferElements from 'transfer-elements';
import axios from "axios";
import '@fortawesome/fontawesome-free/js/all.js';
import {updateTotal} from "../components/OrderForm.js";

window.application = window.application || {}
window.$ = window.jQuery = $;
window._ = _;

const notifier = new AWN({})
window.notifier = notifier

export const api = axios.create();
window.api = api;
// // Добавляем перехватчик ответов
// api.interceptors.response.use(
// 	response => response.data.data,
// 	error => Promise.reject(error)
// );

api.interceptors.response.use(
	function (response) {
		if (response.data.result === false) {
			notifier.alert(response.data.message)
			// return Promise.reject(response)
		}
		return response.data
	},
	function (reject) {
		console.log('Axios reject on response', reject.response)
	}
)
export async function loadTreeData(){
	const response = await api.get('/api/getTree'),
		data = response.data;
	return {data: data};
}
export function getScrollWidth(e) {
	'use strict';

	const body = document.body;

	const documentRoot = document.querySelector(':root');

	const scrollWidth = window.innerWidth - body.offsetWidth;

	documentRoot.style.setProperty('--scroll-width', `${scrollWidth}px`);
}
export function disableScroll() {
	const html = document.documentElement;

	const body = document.body;

	const documentRoot = document.querySelector(':root');

	let pagePosition = window.scrollY;

	body.classList.add('stop-scroll');

	body.dataset.position = pagePosition;

	documentRoot.style.setProperty('--top-position', `-${pagePosition}px`);

	html.style.scrollBehavior = 'unset';
}
export function enableScroll() {
	const html = document.documentElement;

	const body = document.body;

	const documentRoot = document.querySelector(':root');

	let pagePosition = parseInt(body.dataset.position, 10);

	body.classList.remove('stop-scroll');

	window.scroll({
		top: pagePosition,

		left: 0
	});

	body.removeAttribute('data-position');

	documentRoot.style.setProperty('--top-position', 'auto');

	html.style.scrollBehavior = '';
}
export function slideDown(target, duration) {
	target.style.removeProperty('display');
	let display = window.getComputedStyle(target).display;
	if (display === 'none') display = 'flex';
	target.style.display = display;
	let height = target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight;
	target.style.boxSizing = 'border-box';
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.height = height + 'px';
	target.style.border = 'none';
	target.style.removeProperty('padding-top');
	target.style.removeProperty('padding-bottom');
	target.style.removeProperty('margin-top');
	target.style.removeProperty('margin-bottom');
	target.style.removeProperty('border');

	window.setTimeout(() => {
		target.style.removeProperty('height');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		target.style.removeProperty('border');
	}, duration);
}
export function slideUp(target, duration) {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = duration + 'ms';
	target.style.boxSizing = 'border-box';
	target.style.height = target.offsetHeight + 'px';
	target.offsetHeight;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.style.border = 'none';

	window.setTimeout(() => {
		target.style.display = 'none';
		target.style.removeProperty('height');
		target.style.removeProperty('padding-top');
		target.style.removeProperty('padding-bottom');
		target.style.removeProperty('margin-top');
		target.style.removeProperty('margin-bottom');
		target.style.removeProperty('overflow');
		target.style.removeProperty('transition-duration');
		target.style.removeProperty('transition-property');
		target.style.removeProperty('border');
	}, duration);
}
export function slideToggle(target, duration) {
	if (window.getComputedStyle(target).display === 'none') {
		return slideDown(target, duration);
	} else {
		return slideUp(target, duration);
	}
}
export function getElementHeight(selector, varHeightName) {
	function heightDetermination() {
		const element = document?.querySelector(selector);

		if (element) {
			const elementHeight = element.offsetHeight;

			const documentRoot = document.querySelector(':root');

			documentRoot.style.setProperty(varHeightName, `${elementHeight}px`);
		}
	}

	heightDetermination();

	window.addEventListener('resize', () => {
		heightDetermination();
	});
}
export function spoilers(durationSpeed) {
	'use strict';

	// Собираем все элементы с атрибутом data-spoilers
	const spoilersArray = document?.querySelectorAll('[data-spoilers]');

	// Проверяем есть ли они
	if (spoilersArray.length > 0) {
		// Получение обычных спойлеров
		const spoilersRegular = Array.from(spoilersArray).filter(function (
			item,
			index,
			self
		) {
			return !item.dataset.spoilers.split(',')[0];
		});

		// Инициализация обычных спойлеров
		if (spoilersRegular.length > 0) {
			initSpoilers(spoilersRegular);
		}

		// Получение спойлеров с медиазапросами
		const spoilersMedia = Array.from(spoilersArray).filter(function (
			item,
			index,
			self
		) {
			return item.dataset.spoilers.split(',')[0];
		});

		// Инициализация спойлеров с медиазапросами
		if (spoilersMedia.length > 0) {
			const breakpointsArray = [];

			spoilersMedia.forEach((item) => {
				const params = item.dataset.spoilers;

				const breakpoint = [];

				const paramsArray = params.split(',');

				breakpoint.value = paramsArray[0];

				breakpoint.type = paramsArray[1] ? paramsArray[1].trim() : 'max';

				breakpoint.item = item;

				breakpointsArray.push(breakpoint);
			});

			// Получаем уникальные брейкпоинты
			let mediaQueries = breakpointsArray.map(function (item) {
				return (
					'(' +
					item.type +
					'-width: ' +
					item.value +
					'px),' +
					item.value +
					',' +
					item.type
				);
			});

			mediaQueries = mediaQueries.filter(function (item, index, self) {
				return self.indexOf(item) === index;
			});

			// Работаем с каждым брейкпоинтом
			mediaQueries.forEach((breakpoint) => {
				const paramsArray = breakpoint.split(',');

				const mediaBreakpoint = paramsArray[1];

				const mediaType = paramsArray[2];

				const matchMedia = window.matchMedia(paramsArray[0]);

				// Объекты с нужными условиями
				const spoilersArray = breakpointsArray.filter(function (item) {
					if (item.value === mediaBreakpoint && item.type === mediaType) {
						return true;
					}
				});

				// Событие
				matchMedia.addEventListener('change', function () {
					initSpoilers(spoilersArray, matchMedia);
				});

				initSpoilers(spoilersArray, matchMedia);
			});
		}
	}

	// Инициализация
	function initSpoilers(spoilersArray, matchMedia = false) {
		spoilersArray.forEach((spoilersBlock) => {
			spoilersBlock = matchMedia ? spoilersBlock.item : spoilersBlock;

			if (matchMedia.matches || !matchMedia) {
				spoilersBlock.classList.add('init');

				initSpoilerBody(spoilersBlock);

				spoilersBlock.addEventListener('click', setSpoilerAction);
			} else {
				spoilersBlock.classList.remove('init');

				initSpoilerBody(spoilersBlock, false);

				spoilersBlock.removeEventListener('click', setSpoilerAction);
			}
		});
	}

	// Работа с контентом
	function initSpoilerBody(spoilersBlock, hideSpoilerBody = true) {
		const spoilerTitles = spoilersBlock.querySelectorAll(
			'[data-spoiler-title]'
		);

		if (spoilerTitles.length > 0) {
			spoilerTitles.forEach((spoilerTitle) => {
				if (hideSpoilerBody) {
					spoilerTitle.removeAttribute('tabindex');

					if (!spoilerTitle.classList.contains('active')) {
						const spoilerTitleParent = spoilerTitle?.closest(
							'[data-spoiler]'
						);

						if (spoilerTitleParent) {
							const targetContent = spoilerTitleParent.querySelector(
								'[data-spoiler-content]'
							);

							targetContent.hidden = true;
						}
					}
				} else {
					spoilerTitle.setAttribute('tabindex', '-1');

					const spoilerTitleParent = spoilerTitle?.closest('[data-spoiler]');

					if (spoilerTitleParent) {
						const targetContent = spoilerTitleParent.querySelector(
							'[data-spoiler-content]'
						);

						targetContent.hidden = false;
					}
				}
			});
		}
	}

	function setSpoilerAction(e) {
		const el = e.target;

		if (
			el.hasAttribute('data-spoiler-title') ||
			el.closest('[data-spoiler-title]')
		) {
			const spoilerTitle = el.hasAttribute('data-spoiler-title')
				? el
				: el.closest('[data-spoiler-title]');

			const spoilersBlock = spoilerTitle.closest('[data-spoilers]');

			const oneSpoiler = spoilersBlock.hasAttribute('data-one-spoiler')
				? true
				: false;

			if (!spoilersBlock.querySelectorAll('.slide').length) {
				if (oneSpoiler && !spoilerTitle.classList.contains('active')) {
					hideSpoilersBody(spoilersBlock);
				}

				spoilerTitle.classList.toggle('active');

				const spoilerTitleParent = spoilerTitle.closest('[data-spoiler]');

				const targetContent = spoilerTitleParent.querySelector(
					'[data-spoiler-content]'
				);

				slideToggle(targetContent, durationSpeed);
			}
			e.preventDefault();
		}
	}

	function hideSpoilersBody(spoilersBlock) {
		const spoilerActiveTitle = spoilersBlock.querySelector(
			'[data-spoiler-title].active'
		);

		const activeTitleParent = spoilerActiveTitle.closest('[data-spoiler]');

		const targetContent = activeTitleParent.querySelector(
			'[data-spoiler-content]'
		);

		if (spoilerActiveTitle) {
			spoilerActiveTitle.classList.remove('active');

			slideUp(targetContent, durationSpeed);
		}
	}
}
export function initApp() {

	getScrollWidth();

	getElementHeight('.site-header', '--header-height');

	(function burger() {
		'use strict';

		const burger = document?.querySelector('[data-burger]');

		const nav = document?.querySelector('[data-nav]');
		const navItems = document?.querySelectorAll('[data-nav-item]');

		const overlay = document?.querySelector('[data-nav-overlay]');

		if (burger && nav) {
			burger.addEventListener('click', () => {
				burger.classList.toggle('burger--is-active');

				nav.classList.toggle('nav--is-visible');

				if (burger.getAttribute('aria-expanded') === 'false') {
					burger.setAttribute('aria-expanded', 'true');

					burger.setAttribute('aria-label', 'Закрыть меню');

					disableScroll();
				} else {
					burger.setAttribute('aria-expanded', 'false');

					burger.setAttribute('aria-label', 'Открыть меню');

					enableScroll();
				}
			});
		}

		if (navItems) {
			navItems.forEach((el) => {
				el.addEventListener('click', () => {
					enableScroll();

					if (burger) {
						burger.setAttribute('aria-expanded', 'false');

						burger.setAttribute('aria-label', 'Открыть меню');

						burger.classList.remove('burger--is-active');
					}

					if (nav) {
						nav.classList.remove('nav--is-active');
					}
				});
			});
		}

		if (overlay) {
			overlay.addEventListener('click', () => {
				if (burger) {
					burger.setAttribute('aria-expanded', 'false');

					burger.setAttribute('aria-label', 'Открыть меню');

					burger.classList.remove('burger--is-active');
				}

				if (nav) {
					nav.classList.remove('nav--is-active');
				}

				enableScroll();
			});
		}
	})();

	(function selectExpanded() {
		'use strict';

		// Собираем все элементы с атрибутом "data-selects"
		const selects = document?.querySelectorAll('[data-select]');

		if (selects) {
			selects.forEach((item) => {
				item.addEventListener('click', (e) => {
					const target = e.target;

					if (target.closest('[data-select-title]')) {
						const parent = target?.closest('[data-select]');

						target.classList.toggle('is-active');

						const content = parent?.querySelector('[data-select-content]');

						content.classList.toggle('is-active');

						const titleHeight = e.target.closest('[data-select-title]')
							.offsetHeight;

						const rootElement = document.documentElement;

						rootElement.style.setProperty(
							'--select-title-height',
							`${titleHeight}px`
						);

						slideToggle(content, 300);

						if (target.getAttribute('aria-expanded') == 'false') {
							target.setAttribute('aria-expanded', true);
						} else {
							target.setAttribute('aria-expanded', false);
						}
					}

					if (target.closest('[data-option-inner-button]')) {
						const parent = target?.closest('[data-select]');

						const innerBtns = parent.querySelectorAll(
							'[data-option-inner-button]'
						);

						innerBtns.forEach((item) => {
							item.classList.remove('is-active');
						});

						target.classList.add('is-active');

						const innerInfo = target.innerHTML;

						const content = parent.querySelector('[data-select-content]');

						slideUp(content, 300);

						content.classList.remove('is-active');

						const title = parent.querySelector('[data-select-title]');

						title.innerHTML = innerInfo;

						title.setAttribute('aria-expanded', false);

						title.classList.remove('is-active');

						const btnName = target.dataset.optionInnerButton;

						if (parent.hasAttribute('data-select-socials')) {
							const targetsOptions = document?.querySelectorAll(
								`[data-option-inner-btn-target="${btnName}"]`
							);

							targetsOptions.forEach((item) => {
								const parentTarget = item.closest('[data-calc]');

								const allTargets = parentTarget?.querySelectorAll(
									'[data-option-inner-btn-target]'
								);

								if (allTargets) {
									allTargets.forEach((item) => {
										if (!item.hasAttribute('data-tariff-info')) {
											item.classList.remove('is-active');
										}

										const itemName = item.dataset.optionInnerBtnTarget;

										if (itemName == btnName) {
											item.classList.add('is-active');
										}
									});
								}
							});
						} else {
							const targetOption = document?.querySelector(
								`[data-option-inner-btn-target="${btnName}"]`
							);

							if (targetOption) {
								const parentTarget = targetOption.closest(
									'[data-tabs-content-inner]'
								);

								const allTargets = parentTarget?.querySelectorAll(
									'[data-option-inner-btn-target]'
								);

								if (allTargets) {
									allTargets.forEach((item) => {
										item.classList.remove('is-active');

										const itemName = item.dataset.optionInnerBtnTarget;

										if (itemName == btnName) {
											item.classList.add('is-active');
										}
									});
								}
							}
						}
					}

					document.addEventListener('click', function (e) {
						const target = e.target;

						if (!target.closest('[data-select]')) {
							const titles = document?.querySelectorAll('[data-select-title]');

							titles.forEach(function (item, index, array) {
								item.classList.remove('is-active');
								item.setAttribute('aria-expanded', false);
							});

							const contents = document?.querySelectorAll(
								'[data-select-content]'
							);

							contents.forEach(function (item, index, array) {
								slideUp(item, 300);
							});
						}
					});
				});
			});
		}
	})();

	(function tabs() {
		'use strict';

		const tabsParents = document?.querySelectorAll('[data-tabs-parent]');

		if (tabsParents.length > 0) {
			tabsParents.forEach((el) => {
				el.addEventListener('click', (e) => {
					const parent = e.target.closest('[data-tabs-parent]');

					if (e.target.closest('[data-tabs-path]')) {
						const tabsPath = e.target.closest('[data-tabs-path]').dataset
							.tabsPath;

						const parentBtns = e.target.closest('[data-tabs-buttons]');

						const btns = parentBtns?.querySelectorAll('[data-tabs-path]');

						btns.forEach((el) => {
							el.classList.remove('tabs__btn--active');
						});

						e.target.classList.add('tabs__btn--active');

						tabsHandler(tabsPath, parent);
					}
				});
			});
		}

		const tabsHandler = (path, parent) => {
			const target = parent?.querySelector(`[data-tabs-target="${path}"]`);

			if (target) {
				if (target.classList.contains('tabs__content--main')) {
					const targetParent = target.closest('[data-tabs-contents]');

					const tabsContents = targetParent?.querySelectorAll(
						'.tabs__content--main'
					);

					tabsContents.forEach((el) => {
						el.classList.remove('tabs__content--active');
					});
				} else if (target.closest('.tabs-contents__data')) {
					const targetParent = target.closest('.tabs-contents__data');

					const tabsContents = targetParent?.querySelectorAll(
						'[data-tabs-target]'
					);

					tabsContents.forEach((el) => {
						el.classList.remove('tabs__content--active');
					});
				} else {
					const targetParent = target.closest('[data-tabs-contents]');

					const tabsContents = targetParent?.querySelectorAll(
						'[data-tabs-target]'
					);

					tabsContents.forEach((el) => {
						el.classList.remove('tabs__content--active');
					});
				}

				target.classList.add('tabs__content--active');
			}
		};
	})();

	(function sliderReviews() {
		'use strict';

		const swiperEl = document?.querySelector('.reviews-slider');

		if (swiperEl) {
			const swiper = new Swiper(swiperEl, {
				modules: [Navigation],
				loop: true,
				slidesPerView: 1,

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev'
				}
			});
		}
	})();

	(function goBackTop() {
		'use strict';

		// Получаем кнопку в переменную
		const btn = document?.querySelector('[data-go-back-top]');

		function btnActive() {
			// Сколько нужно проскролить, чтобы появилась кнопка
			const breakpoint = 1000;

			// Если прокрутили на значение breakpoint, задаём кнопке указанный класс
			if (window.scrollY >= breakpoint) {
				btn.classList.add('is-active');
			} else {
				btn.classList.remove('is-active');
			}
		}

		if (btn) {
			window.addEventListener('scroll', btnActive);

			btn.addEventListener('click', function () {
				window.scrollTo({
					top: 0,
					left: 0,
					behavior: 'smooth'
				});
			});
		}
	})();

	(function readProgressLine() {
		'use strict';

		// Добавляем в body блок для линии прогресса прокрутки
		let lineAppend = document.createElement('div');

		lineAppend.className = 'progress-line';

		lineAppend.innerHTML = '<div class="progress-line__item"></div>';

		document.body.append(lineAppend);

		// Получаем внутренний элемент оболочки линии прогресса прокрутки
		const line = document.querySelector('.progress-line__item');

		const progressAnimation = () => {
			let scrollTop = window.scrollY;

			let windowHeight = window.innerHeight;

			let siteHeight = document.documentElement.scrollHeight;

			let percentageProgress = Math.floor(
				(scrollTop / (siteHeight - windowHeight)) * 100
			);

			line.style.width = `${percentageProgress}%`;
		};

		progressAnimation();

		window.addEventListener('scroll', () => {
			progressAnimation();
		});
	})();

	spoilers(500);

	(function transferHeaderBtns() {
		const btns = document?.querySelector('[data-header-btns]');

		if (btns) {
			new TransferElements({
				sourceElement: btns,

				breakpoints: {
					768: {
						targetElement: document?.querySelector('[data-nav]'),
						targetPosition: 1
					}
				}
			});
		}
	})();

	(function formBlockVisibleHide() {
		'use strict';

		const form = document?.querySelector('.free-cheat__form');

		if (form) {
			const optBtns = form?.querySelectorAll('[data-option-inner-button]');

			const targets = form?.querySelectorAll('[data-select-target]');

			if (optBtns && targets) {
				optBtns.forEach((el) => {
					el.addEventListener('click', (e) => {
						const path = e.target.dataset.optionInnerButton;

						optBtns.forEach((el) => {
							el.classList.remove('is-active');
						});

						e.target.classList.add('is-active');

						targets.forEach((el) => {
							el.classList.remove('is-visible');

							const name = el.dataset.selectTarget;

							if (name == path) {
								el.classList.add('is-visible');
							} else {
								el.classList.remove('is-visible');
							}
						});
					});
				});
			}
		}
	})();
}
